import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import {defineMessages, injectIntl} from 'react-intl';
import Modal from '../../components/modal/modal.jsx';
import Box from '../box/box.jsx';
import styles from './online-search-modal.css';

const messages = defineMessages({
    searchOnline: {
        id: 'gui.onlineSearchModal.searchOnline',
        defaultMessage: 'Tìm kiếm Online',
        description: 'Title for online search modal'
    },
    searchPlaceholder: {
        id: 'gui.onlineSearchModal.searchPlaceholder',
        defaultMessage: 'Nhập từ khóa tìm kiếm...',
        description: 'Placeholder for online search input'
    }
});

const OnlineSearchModalComponent = props => (
    <Modal
        className={styles.modalContent}
        contentLabel={props.intl.formatMessage(messages.searchOnline)}
        id="onlineSearchModal"
        onRequestClose={props.onRequestClose}
    >
        <Box className={styles.body}>
            <div className={styles.searchHeader}>
                <input
                    className={styles.searchInput}
                    placeholder={props.intl.formatMessage(messages.searchPlaceholder)}
                    value={props.searchTerm}
                    onChange={props.onChangeSearchTerm}
                    onKeyDown={props.onKeyDown}
                />
                <button
                    className={styles.searchButton}
                    onClick={props.onSearch}
                >
                    Tìm kiếm
                </button>
            </div>
            
            <div className={styles.resultsGrid}>
                {props.results.map((result, index) => (
                    <div 
                        key={index} 
                        className={styles.resultItem}
                        onClick={() => props.onSelectImage(result.url, result.title)}
                    >
                        <img src={result.thumbnail} alt={result.title} />
                        <div className={styles.resultTitle}>{result.title}</div>
                    </div>
                ))}
                
                {props.hasMore && (
                    <div 
                        className={classNames(styles.resultItem, styles.loadMoreItem)}
                        onClick={props.onLoadMore}
                    >
                        <div className={styles.loadMoreText}>
                            {props.isLoading ? 'Đang tải...' : 'Xem thêm'}
                        </div>
                    </div>
                )}
            </div>
        </Box>
    </Modal>
);

OnlineSearchModalComponent.propTypes = {
    intl: PropTypes.object.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    searchTerm: PropTypes.string.isRequired,
    onChangeSearchTerm: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onSelectImage: PropTypes.func.isRequired,
    onLoadMore: PropTypes.func.isRequired,
    hasMore: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    results: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string,
        thumbnail: PropTypes.string,
        title: PropTypes.string
    })).isRequired
};

export default injectIntl(OnlineSearchModalComponent);
